<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>MAC配置</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <div>
            <Button type="primary" icon="plus-round" @click="pathAdd" v-if="authList.indexOf('006001') !== -1">批量添加</Button>
            <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('006001') !== -1">删除</Button>
            <Button type="ghost" icon="ios-cloud-download-outline" @click="exportDevice" v-if="authList.indexOf('006002') !== -1">导出</Button>
          </div>

          <div>
            <Select v-model="reqbody.lotNo" style="width:120px" placeholder="生产批次" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in lotList" :value="item.lotNo" :key="item.lotNo">{{ item.lotNo }}</Option>
            </Select>
            <Select v-model="reqbody.firewareNo" style="width:120px;margin-left: 20px;" placeholder="固件版本" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in firewareList" :value="item.firmwareNo" :key="item.firmwareNo">{{ item.firmwareNo }}</Option>
            </Select>
            <Select v-model="reqbody.productModel" style="width:120px;margin-left: 20px;" placeholder="产品型号" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in productModelList" :value="item.productIdentity" :key="item.productIdentity">{{ item.productModelName }}</Option>
            </Select>
            <Select v-model="reqbody.useStatus" style="width:120px;margin-left: 20px;" placeholder="使用状态" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in useStatusList" :value="item.id" :key="item.id">{{ item.useStatus }}</Option>
            </Select>
          </div>

          <div>
            <Input v-model="reqbody.deviceNo" icon="ios-search" placeholder="设备编号" :maxlength=32 style="width: 200px" @on-click="search" @keyup.13.native="search"/>
          </div>
        </div>

        <Table border height="520" ref="factory_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
        <page :total="total" show-sizer :page-size-opts="pageSizeArr" class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>

    <Modal
      v-model="deleteSelectMAC"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除所选MAC配置？</p>
    </Modal>

    <Modal
      v-model="openSimple"
      title="批量添加"
      @on-ok="sureAdd"
      @on-cancel="cancelAdd">
      <p style="margin-bottom: 10px;">
        <span style="margin-right: 10px;font-size: 14px;"><span style="color: red;">*</span>请输入需要添加的数量</span>
        <InputNumber :max="10000" :min="1" v-model="amount"></InputNumber>
      </p>
      <p style="margin-bottom: 10px;">
        <span style="margin-right: 10px;font-size: 14px;"><span style="color: red;">*</span>请选择需要添加的批次</span>
        <Select v-model="lotNo" style="width:200px">
          <Option v-for="item in lotList" :value="item.lotNo" :key="item.lotNo">{{ item.lotNo }}</Option>
        </Select>
      </p>
      <p style="margin-bottom: 10px;">
        <span style="margin-right: 10px;font-size: 14px;"><span style="color: red;">*</span>请选择需要添加的版本</span>
        <Select v-model="firewareNo" style="width:200px">
          <Option v-for="item in firewareList" :value="item.firmwareNo" :key="item.firmwareNo">{{ item.firmwareNo }}</Option>
        </Select>
      </p>
      <p>
        <span style="margin-right: 10px;font-size: 14px;"><span style="color: red;">*</span>请选择需要添加的型号</span>
        <Select v-model="productModel" style="width:200px">
          <Option v-for="item in productModelList" :value="item.productIdentity" :key="item.productIdentity">{{ item.productModelName }}</Option>
        </Select>
      </p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nError, nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'factory-allocation',
  data () {
    return {
      authList: '',
      total: 0,
      pageSizeArr: [10, 20, 50, 100],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '设备编号',
          key: 'deviceNo',
          align: 'center'
        }, {
          title: '有线mac',
          key: 'macAddr',
          align: 'center'
        }, {
          title: '使用状态',
          key: 'statusShow',
          align: 'center'
        }, {
          title: '创建时间',
          key: 'createTime',
          align: 'center'
        }
      ],
      reqbody: {
        lotNo: '',
        firewareNo: '',
        productModel: '',
        useStatus: '',
        deviceNo: '',
        pageSize: 10,
        pageNo: 1
      },
      amount: 1,
      tableData: [],
      openSimple: false,
      deleteSelectMAC: false,
      lotNo: '',
      firewareNo: '',
      productModel: '',
      lotList: [],
      productModelList: [],
      firewareList: [],
      useStatusList: [{
        id: '0',
        useStatus: '未使用'
      }, {
        id: '1',
        useStatus: '已使用'
      }],
      batchIds: ''
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getFirmwareList()
    this.getLotList()
    this.getProductModelList()
    this.getFactorySettingPage()
  },
  methods: {
    getFirmwareList () {
      this.$axios.post(`${httpUrl.url}/manage/firmware/getList`, {})
        .then(res => {
          this.firewareList = res.data.data
        })
        .catch(errorHandler('获取版本数据失败'))
    },
    getLotList () {
      this.$axios.post(`${httpUrl.url}/manage/lot/getList`, {})
        .then(res => {
          this.lotList = res.data.data
        })
        .catch(errorHandler('获取批次数据失败'))
    },
    getProductModelList () {
      this.$axios.post(`${httpUrl.url}/manage/productModel/getList`, {})
        .then(res => {
          this.productModelList = res.data.data
        })
        .catch(errorHandler('获取产品型号列表失败'))
    },
    getFactorySettingPage () {
      this.$axios.post(`${httpUrl.url}/manage/factorySetting/getPage`, this.reqbody)
        .then(res => {
          let data = res.data.data
          data.list.map(v => {
            if (v.useStatus === '1') {
              v.statusShow = '已使用'
              v._disabled = true
            } else {
              v.statusShow = '未使用'
              v._disabled = false
            }
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            } else {
              v.createTime = '--'
            }
          })
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    addFactory () {
      this.$axios.post(`${httpUrl.url}/manage/factorySetting/add`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.reqbody.pageNo = 1
            this.getFactorySettingPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    pathAdd () {
      this.openSimple = true
    },
    batchDelete () {
      this.deleteSelectMAC = true
    },
    sureAdd () {
      if (!this.amount) {
        nError('添加数量必填')
        return false
      }
      if (!this.lotNo) {
        nError('添加批次必填')
        return false
      }
      if (!this.firewareNo) {
        nError('添加版本必填')
        return false
      }
      if (!this.productModel) {
        nError('添加型号必填')
        return false
      }
      let obj = {}
      obj.amount = this.amount
      obj.lotNo = this.lotNo
      obj.firewareNo = this.firewareNo
      obj.productModel = this.productModel
      this.$axios.post(`${httpUrl.url}/manage/factorySetting/addPatch`, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.amount = 1
            this.lotNo = ''
            this.firewareNo = ''
            this.productModel = ''
            this.reqbody.pageNo = 1
            this.getFactorySettingPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancelAdd () {
      this.amount = 1
      this.lotNo = ''
      this.firewareNo = ''
    },
    // 导出
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchIds = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchIds = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchIds = idArr.join(',')
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/factorySetting/deleteByIds`, {
        ids: this.batchIds
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.deleteSelectMAC = false
            this.reqbody.pageNo = 1
            this.getFactorySettingPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.deleteSelectMAC = false
    },
    exportDevice () {
      if (!this.batchIds) {
        nError('请先选择需要导出的设备')
        return false
      }
      let exportUrl = `${httpUrl.url}/manage/factorySetting/export?firewareNo=${this.reqbody.firewareNo}&lotNo=${this.reqbody.lotNo}&deviceNo=${this.reqbody.deviceNo}&useStatus=${this.reqbody.useStatus}&ids=${this.batchIds}`
      console.log(exportUrl)
      this.downloadFile('', exportUrl)
    },
    downloadFile (fileName, href) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      eleLink.href = href
      eleLink.click()
      setTimeout(() => {
        this.getFactorySettingPage()
        this.batchIds = ''
      }, 1000)
    },
    search () {
      this.reqbody.pageNo = 1
      this.getFactorySettingPage()
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getFactorySettingPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getFactorySettingPage()
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/factory-allocation/factory-allocation.vue